module.exports = __webpack_public_path__ + "static/media/editPen16.2fe58f93.svg";